import { render, staticRenderFns } from "./VacancyData.vue?vue&type=template&id=2ff82c73&"
import script from "./VacancyData.vue?vue&type=script&lang=js&"
export * from "./VacancyData.vue?vue&type=script&lang=js&"
import style0 from "./VacancyData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports